/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 09:59:35
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-15 10:57:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/List/index.tsx
 */

import React, { memo, ReactNode, useState } from 'react';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';

import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import { MenuItemType } from '@/src/components/BulkEditor/BulkEditor';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import {
  bulkActivateDiscount,
  bulkArchiveDiscount,
  bulkCloneDiscount,
  bulkDraftDiscount,
} from '@/src/request/salesChannel/discounts';
import { getDirectDiscountList } from '@/src/request/salesChannel/discounts/directDiscount';
import { NEW } from '@/src/tools/constant';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Modal } from 'src/components/Antd';
import { handleClick } from 'src/constrains/CreateButtonWithLanguageChangeWarning/tools';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { EDiscountType, EnumStatus } from 'src/types/common/discount';
import css from './css.module.less';
import { activeChange, setAllDataTotal } from './slice';

import NoPermission from '@/src/components/NoPermission';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { defaultPageSize } from 'src/tools/constant';
import { i18nGet, handleOnGetCurrentSCTimezoneUTC } from 'src/tools/tools';
import { discountPermissions } from '../../Components/hooks/permissions';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import {
  // addButtonMenu,
  breadcrumbData,
  columns,
  filterList,
  ModalType,
  StatusChange,
  tabsConfig,
} from './config';

interface IParams {
  uuid: string;
}

const DirectDiscountList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();
  const state = useSelector(
    (state: any) => state.SalesChannelDiscountsDirectDiscount,
  );
  const params = useParams<IParams>();
  const history = useHistory();
  const {
    // sort,
    // searchList: searchListArray,
    // filter,
    tabsActive,
    allDataTotal,
    // tableSettings,
  } = state;

  const { uuid: salesChannelUuid } = params;
  const { canViewList, canEdit, canDelete, canViewDetail } =
    discountPermissions(salesChannelUuid);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [directDiscount, setDirectDiscount] = useState([]);
  // const [timezoneInGmt, setTimezoneInGmt] = React.useState('');
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState<any>();
  const [salesChannelName, setSalesChannelName] = useState('');
  const flashSaleConvertQuery = (filter) => {
    const re: any = {};
    re.discountStatuses = (filter.discountStatuses || []).map(
      (status) => status.value,
    );
    re.discountTypes = (filter.discountTypes || []).map(
      (status) => status.value,
    );
    return re;
  };

  const { clearSearchState, queryProps, search } = useQueries(
    filterList(tabsActive, { getI18n }),
    [],
    flashSaleConvertQuery,
  );

  /* 弹窗 */
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
  const [modalContent, setModalContent] = useState<ReactNode>('');

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(directDiscount);

  const addFun = () => {
    handleClick({
      onClick: () => {
        history.push(
          `/salesChannel/discounts/directDiscount/editor/${salesChannelUuid}/${NEW}?defaultName=Direct Discount ${
            allDataTotal + 1
          }`,
        );
      },
      title: getI18n('salesChannelDirectDiscount.list.addDirectDiscount'),
      content: getI18n('salesChannelDirectDiscount.list.switchLang'),
      onOkText: getI18n('general.antd.Uploader.ok'),
      onCancelText: getI18n('general.cancel'),
      salesChannelUuid,
    });
  };

  const statusChangeModal = (uuid, type: ModalType) => {
    const notAblePublishText = (
      <div>
        <div className={css.errorPublish}>
          {type == ModalType.ArchiveDiscount
            ? getI18n('salesChannelDirectDiscount.list.archiveTip')
            : getI18n('salesChannelDirectDiscount.list.archiveTip2')}
        </div>{' '}
        <ModalFooter
          onCancel={() => setShowModal(false)}
          okText={
            type == ModalType.ArchiveDiscount
              ? getI18n('general.status.archive')
              : getI18n('general.gotoedit')
          }
          onOk={() =>
            type == ModalType.ArchiveDiscount
              ? handleChangeStatus(uuid, StatusChange.Archive)
              : handleGotoEdit(uuid)
          }
        />
      </div>
    );
    setModalContent(notAblePublishText);
    setModalTitle(
      type == ModalType.ArchiveDiscount
        ? getI18n('salesChannelDirectDiscount.list.archiveDiscount')
        : getI18n('general.unabletoPublish'),
    );
    setShowModal(true);
  };

  const buttonMenu = () => {
    let showSwitchDraft = false;
    if (selectedRowKeys.length > 0) {
      const selectedItems = directDiscount.filter((o) =>
        selectedRowKeys.includes(o.uuid),
      );
      const selectedItemsStatus = selectedItems.map((item) => item.status);
      if (!selectedItemsStatus.includes(EnumStatus.Draft)) {
        showSwitchDraft = true;
      }
    }
    return [
      //Bulk Edit
      ...(tabsActive !== EnumStatus.Archived && showSwitchDraft
        ? [
            {
              key: 1,
              value: getI18n('general.switchToDraft'),
              type: MenuItemType.Primary,
              function: () =>
                handleChangeStatus(selectedRowKeys, StatusChange.ToDraft),
              disabled: !canEdit,
            },
          ]
        : []),
      ...(tabsActive !== EnumStatus.Archived
        ? [
            // {
            //   key: 2,
            //   value: getI18n('general.duplicate'),
            //   type: MenuItemType.Primary,
            //   function: () =>
            //     handleChangeStatus(selectedRowKeys, StatusChange.Duplicate),
            //   disabled: !canEdit,
            // },
            {
              key: 3,
              value: getI18n('general.archive'),
              type: MenuItemType.Error,
              function: () =>
                statusChangeModal(selectedRowKeys, ModalType.ArchiveDiscount),
              disabled: !canDelete,
            },
          ]
        : []),
      ...(tabsActive == EnumStatus.Archived
        ? [
            {
              key: 4,
              value: getI18n('general.restore'),
              type: MenuItemType.Primary,
              function: () =>
                handleChangeStatus(selectedRowKeys, StatusChange.ToDraft),
              disabled: !canEdit,
            },
          ]
        : []),
    ];
  };

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  //关闭弹窗
  const onModalCancel = () => {
    setShowModal(false);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    dispatch(activeChange(activeKey));
  };

  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    const auto =
      tabsActive == EnumStatus.Auto
        ? true
        : tabsActive == EnumStatus.PromoCode
        ? false
        : null;
    const status =
      tabsActive == EnumStatus.Archived
        ? { discountStatuses: [tabsActive] }
        : data.discountStatuses.length
        ? { discountStatuses: data.discountStatuses }
        : {
            discountStatuses: [
              EnumStatus.Active,
              EnumStatus.Draft,
              EnumStatus.Expired,
              EnumStatus.Scheduled,
            ],
          };

    const discountTypes = data.discountTypes.length
      ? data.discountTypes
      : Object.values(EDiscountType);
    const _data = { ...data, ...status, auto, sortBy, discountTypes };
    getDirectDiscountList(
      {
        ..._data,
        salesChannelUuid: salesChannelUuid,
      },
      current * pageSize,
      pageSize,
    ).then((res) => {
      const { salesChannelName } = res;
      const { totalCount, results } = res.discounts as any;
      setTotal(totalCount);
      setSalesChannelName(salesChannelName);
      setDirectDiscount(results);
      // setTimezoneInGmt(timezoneInGmt);
      setLoading(false);
      if (!tabsActive) {
        dispatch(setAllDataTotal(totalCount));
      }
    });
  };

  React.useEffect(() => {
    if (canViewList) {
      getProduct(() => void 0);
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (canViewList) {
      getProduct(() => void 0);
    }
  }, [tabsActive, current]);

  useAfterDidMountEffect(() => {
    if (canViewList) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy]);

  const pageLayoutProps = {
    title: getI18n('general.directDiscount'),
    // addButtonOverlay,
    addText: getI18n('salesChannelDirectDiscount.list.addDirectDiscount'),
    addFun,
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig({ getI18n }),
    disableAdd: !canEdit,
  };

  const handleGotoEdit = (uuid) => {
    handleClick({
      onClick: () => {
        history.push(
          `/salesChannel/discounts/directDiscount/editor/${salesChannelUuid}/${uuid}`,
        );
      },
      title: getI18n('salesChannelDirectDiscount.list.editDirectDiscount'),
      content: getI18n('salesChannelDirectDiscount.list.switchLang'),
      onOkText: getI18n('general.antd.Uploader.ok'),
      onCancelText: getI18n('general.cancel'),
      salesChannelUuid,
    });
  };

  const handleChangeStatus = (uuids, type, canPublish?) => {
    if (canPublish === false && type == StatusChange.Publish) {
      statusChangeModal(uuids[0], ModalType.UnableToPublish);
    } else {
      const changeStatusRequestList = {
        [StatusChange.Publish]: bulkActivateDiscount,
        [StatusChange.ToDraft]: bulkDraftDiscount,
        [StatusChange.Archive]: bulkArchiveDiscount,
        [StatusChange.Duplicate]: bulkCloneDiscount,
      };
      changeStatusRequestList[type](uuids).then(() => {
        setShowModal(false);
        getProduct(() => void 0);
      });
    }
  };

  return canViewList ? (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData(salesChannelUuid, salesChannelName, {
          getI18n,
        })}></Breadcrumb>
      <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
        <GlobalTable
          id='ProductListTable'
          //onTableChange={setProducts}
          queryProps={queryProps}
          dataSource={directDiscount}
          columns={columns(
            handleGotoEdit,
            handleChangeStatus,
            statusChangeModal,
            tabsActive,
            scTimezoneUTC,

            !canEdit,
            !canDelete,
            !canViewDetail,
            { getI18n },
          )}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          buttonMenu={buttonMenu()}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          hideRowSelection={!canEdit && !canDelete}
          selectedRowKeys={selectedRowKeys}
          hidePagination={total == 0}
          loading={loading}
          onChange={(_, s, sort) => {
            const ascent = sort.order == 'ascend' ? true : false;
            const field = sort.field;
            setSortBy({ field, ascent });
          }}
        />
      </ListPageLayout>
      <Modal
        width={600}
        visible={showModal}
        title={modalTitle}
        onCancel={onModalCancel}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>
    </React.Fragment>
  ) : (
    <NoPermission />
  );
};

export default SalesChannelModeAccessControlHOC(memo(DirectDiscountList));
